import { Sort } from "@planzone/dto";

import { sortByNameAscending, sortByNameDescending } from "./name";
import { sortDateAscending, sortDateDescending } from "./date";
import { sortByRankAscending, sortByRankDescending } from "./rank";
import { sortByAuthorAscending, sortByAuthorDescending } from "./author";

const sortMap: { [Key in Sort]: Function } = {
  ascendingName: sortByNameAscending,
  descendingName: sortByNameDescending,
  ascendingStartDate: sortDateAscending,
  descendingStartDate: sortDateDescending,
  ascendingEndDate: sortDateAscending,
  descendingEndDate: sortDateDescending,
  ascendingCompletionDate: sortDateAscending,
  descendingCompletionDate: sortDateDescending,
  ascendingCreationDate: sortDateAscending,
  descendingCreationDate: sortDateDescending,
  ascendingRank: sortByRankAscending,
  descendingRank: sortByRankDescending,
  ascendingAuthor: sortByAuthorAscending,
  descendingAuthor: sortByAuthorDescending,
};

function sort<Data extends Array<any>>(
  sort: Sort,
  data: Data,
  extractCriteria: (data: Data[number]) => {
    rank?: number;
    name?: string;
    startDate?: string;
    endDate?: string;
    completionDate?: string;
    creationDate?: string;
    date?: string;
  },
) {
  return data.sort((current, next) =>
    sortMap[sort](extractCriteria(current), extractCriteria(next)),
  );
}

export { sort };
